import { api } from "@/boot/axios"
import { getAuthToken } from "@/boot/axios"
import type { Resident, ResidentDetail } from "@/interfaces/resident"


export function useResident() {

  const getResidentList = async () => {
    try{
      const response = await api.get<Resident[]>('/resident/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch(er) {
      console.error(er)
      return []
    }
  }

  const getResidentDetail = async(uin: string) => {
    try {
      const response = await api.get<ResidentDetail>(`/resident/${uin}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return undefined
    }
  }

  const toggleResidentFavourite = async (residentUin: string) => {
    try{
      const response = await api.post(`/resident/toggle-favourite/${residentUin}`, {}, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return er
    }
  }

  const toggleResidentContact = async (residentUin: string) => {
    try{
      const response = await api.post(`/resident/toggle-contact/${residentUin}`, {}, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return er
    }
  }

  return {
    getResidentList,
    getResidentDetail,
    toggleResidentFavourite,
    toggleResidentContact
  }
}